export type AccountTab =
  | 'profile'
  | 'favorites'
  | 'locations'
  | 'messages'
  | 'announcements'
  | 'orders'
  | 'orderStatistics'
  | 'orderReport'
  | 'settings';

let pendingAccountTab: AccountTab | null = null;

export const requestAccountTabReveal = (tab: AccountTab): void => {
  pendingAccountTab = tab;
};

export const consumeAccountTabReveal = (tab: AccountTab): boolean => {
  if (pendingAccountTab !== tab) {
    return false;
  }

  pendingAccountTab = null;
  return true;
};

export const navigateToAccountTab = (tab: AccountTab, reveal = true): void => {
  const paths: Record<AccountTab, string> = {
    profile: '/profile',
    favorites: '/favorites',
    announcements: '/my-announcements',
    messages: '/messages',
    orders: '/orders',
    orderStatistics: '/order-statistics',
    orderReport: '/order-report',
    locations: '/locations',
    settings: '/settings',
  };

  if (reveal) {
    requestAccountTabReveal(tab);
  }
  window.history.pushState({}, '', paths[tab]);
  window.dispatchEvent(new PopStateEvent('popstate'));
};
